import * as React from "react";
import type { SVGProps } from "react";
const SvgCardDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.1 18.579H4.5a2.4 2.4 0 0 1-2.4-2.4v-9a2.4 2.4 0 0 1 2.4-2.4h14.4a2.4 2.4 0 0 1 2.4 2.4v4.2m-18.6-2.4h18m1.2 7.8-2.454 2.442m0 0L17.1 16.89m2.345 2.332V13.78"
    />
  </svg>
);
export default SvgCardDown;
